import React from 'react'
import PropTypes from 'prop-types'
import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input'
import en from 'react-phone-number-input/locale/en.json'
import it from 'react-phone-number-input/locale/it.json'
import de from 'react-phone-number-input/locale/de.json'

const locales = {
  en,
  it,
  de,
}

const CountrySelect = ({ value, onChange, locale, ...rest }) => {
  const labels = locales[locale] || locales.en

  const sortedCountries = getCountries().sort((a, b) => {
    const upperA = labels[a].toUpperCase()
    const upperB = labels[b].toUpperCase()
    if (upperA < upperB) {
      return -1
    } else if (upperA > upperB) {
      return 1
    } else {
      return 0
    }
  })

  return (
    <select
      {...rest}
      value={value}
      onChange={event => onChange(event.target.value || undefined)}>
      <option value="">
        {labels['ZZ']}
      </option>
      {sortedCountries.map((country) => (
        <option key={country} value={country}>
          {labels[country]} +{getCountryCallingCode(country)}
        </option>
      ))}
    </select>
  )
}

CountrySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired
}

export default CountrySelect
